import { Component, OnInit } from "@angular/core";
import { AadhaarBasedAuthenticationService } from "../../shared/services/aadhaar/aadhaar.service";

@Component({
    selector: "app-aadhaar-verify",
    templateUrl: "./aadhaar-verify.component.html",
    styleUrls: ["./aadhaar-verify.component.scss"]
})
export class AadhaarVerifyComponent implements OnInit {

    hasConsented: boolean = false;
    userData: any = null; // Will hold the Aadhaar profile data once verified

    constructor(
        private aadhaarService: AadhaarBasedAuthenticationService,
    ) {}

    ngOnInit(): void {

        const rawQueryParams = window.location.search;
        console.log("rawQueryParams", rawQueryParams)

        const urlParams = new URLSearchParams(rawQueryParams)

        const client_id = urlParams.get("client_id")
        const status = urlParams.get("status")

        console.log("client_id", client_id)
        console.log("status", status)
    }

    onProceed(): void {
        if (this.hasConsented) {
            // Logic to redirect to DigiLocker or initiate Aadhaar flow goes here
            console.log("Proceeding to Aadhaar Verification...");
            
            this.aadhaarService.getDigilockerConfigUrl()
                .subscribe({
                    next: (res: any) => {
                        if (res && res.url){
                            window.location.href = res.url;
                        }
                    },
                    error: (err: any) => {
                        // alert("Something went wrong, please try again later!")
                        alert(err.message)
                    }
                })
        }
    }

    continueToDashboard(): void {
        // Navigate the user to the dashboard
        // this.router.navigate(['/dashboard']);
    }
}